module.exports = __webpack_public_path__ + "img/soundfield_4.4ec551a1.jpg";